module.exports = __webpack_public_path__ + "c7b207a62a12244ce2f3b36f0344bd0b.svg";